import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsTabpanelCss = ":host{display:block}.pds-tabpanel{display:none;margin-top:var(--tabs-dimension-panel-margin-top);padding:var(--tabs-dimension-panel-padding)}.pds-tabpanel:focus-visible{outline:var(--pine-outline-focus);outline-offset:var(--pine-border-width)}.pds-tabpanel.is-active{display:block}";

const PdsTabpanel$1 = /*@__PURE__*/ proxyCustomElement(class PdsTabpanel extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Keeps track of the tabpanel selected state, this property is passed by parent component
         */
        /** @internal */
        this.selected = false; // eslint-disable-line @stencil-community/strict-mutable
    }
    render() {
        return (h(Host, { key: '021d0c1f2fd740087bdd88069ac82455b8b5ede1', slot: "tabpanels" }, h("div", { key: '036aca9a0a29ba7cfc8aa0132eab027898a661f2', role: "tabpanel", id: this.parentComponentId + "__" + this.name + '-panel', tabindex: "0", "aria-labelledby": this.parentComponentId + "__" + this.name, class: this.selected ? "pds-tabpanel is-active" : "pds-tabpanel" }, h("slot", { key: 'd6b61e7b8af79204dbb5d3e421028715236a7bb1' }))));
    }
    get el() { return this; }
    static get style() { return pdsTabpanelCss; }
}, [4, "pds-tabpanel", {
        "name": [1],
        "parentComponentId": [1, "parent-component-id"],
        "variant": [1],
        "selected": [1028]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-tabpanel"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-tabpanel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsTabpanel$1);
            }
            break;
    } });
}

const PdsTabpanel = PdsTabpanel$1;
const defineCustomElement = defineCustomElement$1;

export { PdsTabpanel, defineCustomElement };
//# sourceMappingURL=pds-tabpanel.js.map

//# sourceMappingURL=pds-tabpanel.js.map